import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['chartdata', 'options', 'chartDataset'],
  mounted () {
    this.renderChart(this.chartdata, this.options)
  },
  watch: {
    chartdata (oldVal, newVal) {
      const chartData = {
        labels: this.chartdata,
        datasets: [
          {
            label: 'Jobs Posted',
            backgroundColor: '#f87279',
            data: this.chartDataset
          }
        ]
      }
      this.renderChart(chartData, this.options)
    }
  }
}
